import React from "react";
import {
	InfoOutlined,
	ShopOutlined,
	BorderOutlined,
	TransactionOutlined,
	DollarOutlined,
	WechatOutlined,
} from "@ant-design/icons";
import BookServiceDetail from "features/book-service/BookServiceDetail";
import { PERMISSION } from "../constants";
import { APP_PATH } from "./../constants/path";
import { lazyRetry } from "utils/route";
import { isProd } from "utils/environment";
import SubscriptionBillingInfor from "features/merchant/tabs/subscription-billing-infor/SubscriptionBillingInforList";
import SubscriptionBillingInforDetail from "features/merchant/tabs/subscription-billing-infor/SubscriptionBillingInforDetail";

// Appointment
const Appointments = React.lazy(() =>
	lazyRetry(() => import("../features/appointment/AppointmentList")),
);
const AppointmentDetail = React.lazy(() =>
	lazyRetry(() => import("../features/appointment/AppointmentDetail")),
);

// Car care appointment
const CarCareAppointments = React.lazy(() =>
	lazyRetry(
		() => import("../features/car-care-appointment/CarCareAppointmentList"),
	),
);

const AccessoriesOrderList = React.lazy(() =>
	lazyRetry(() => import("../features/accessories-order")),
);

const AccessoriesOrderDetail = React.lazy(() =>
	lazyRetry(() => import("../features/accessories-order/detail")),
);

const CarCareAppointmentDetail = React.lazy(() =>
	lazyRetry(
		() => import("../features/car-care-appointment/CarCareAppointmentDetail"),
	),
);

// Purchase
const Purchases = React.lazy(() =>
	lazyRetry(() => import("../features/purchase/ListPurchase")),
);
const PurchaseDetail = React.lazy(() =>
	lazyRetry(() => import("../features/purchase/PurchaseDetail")),
);

// Merchant request
const MerchantRequestList = React.lazy(() =>
	lazyRetry(() => import("../features/merchant-request")),
);
const MerchantRequestCreate = React.lazy(() =>
	lazyRetry(() => import("../features/merchant-request/MerchantRequestCreate")),
);

// Reconciliation
const Reconciliations = React.lazy(() =>
	lazyRetry(() => import("../features/reconciliation/ReconciliationList")),
);
const ReconciliationDetail = React.lazy(() =>
	lazyRetry(() => import("../features/reconciliation/ReconciliationDetail")),
);

const transactionRoutes = {
	label: "Transactions",
	path: "",
	key: "transaction",
	icon: <TransactionOutlined />,
	children: [
		// appointment
		{
			label: "Appointment",
			path: APP_PATH.transactionAppointment,
			key: "transaction-appointment",
			icon: <BorderOutlined />,
			component: <Appointments />,
			permissions: [PERMISSION.TRANSACTIONS.VIEW],
		},
		{
			label: "Appointment details",
			path: `${APP_PATH.transactionAppointment}/:id`,
			key: "",
			icon: <InfoOutlined />,
			component: <AppointmentDetail />,
			hidden: true,
			permissions: [PERMISSION.TRANSACTIONS.VIEW],
		},
		// {
		// 	label: "Book service",
		// 	path: "/transaction-service",
		// 	key: "transaction-service",
		// 	icon: <ShopOutlined />,
		// 	children: [],
		// 	component: <BookService />,
		// 	permissions: [PERMISSION.TRANSACTIONS.VIEW],
		// },
		{
			label: "Transaction Service ID",
			path: `${APP_PATH.transactionService}/:id`,
			key: "transaction-service",
			icon: <ShopOutlined />,
			hidden: true,
			children: [],
			component: <BookServiceDetail />,
			permissions: [PERMISSION.TRANSACTIONS.UPDATE],
		},

		// purchase
		{
			label: "Purchase",
			path: APP_PATH.transactionPurchase,
			key: "transaction-purchase",
			icon: <DollarOutlined />,
			component: <Purchases />,
			permissions: [PERMISSION.TRANSACTIONS.VIEW],
		},
		{
			label: "Purchase detail",
			path: `${APP_PATH.transactionPurchase}/:id`,
			key: "",
			icon: <InfoOutlined />,
			component: <PurchaseDetail />,
			permissions: [PERMISSION.TRANSACTIONS.VIEW],
			hidden: true,
		},

		// Car care appointment
		{
			label: "Car care appointment",
			path: APP_PATH.transactionCarCare,
			key: "transaction-car-care",
			icon: <DollarOutlined />,
			component: <CarCareAppointments />,
			permissions: [PERMISSION.TRANSACTIONS.VIEW],
		},
		{
			label: "Accessories Order",
			path: APP_PATH.transactionCarAccessoryOrders,
			key: "transaction-car-accessory-orders",
			icon: <DollarOutlined />,
			component: <AccessoriesOrderList />,
			permissions: [PERMISSION.TRANSACTIONS.VIEW],
		},
		{
			label: "Accessories Order Detail",
			path: `${APP_PATH.transactionCarAccessoryOrders}/:id`,
			key: "transaction-car-accessory-orders",
			icon: <DollarOutlined />,
			component: <AccessoriesOrderDetail />,
			permissions: [PERMISSION.TRANSACTIONS.VIEW],
			hidden: true,
		},
		{
			label: "Car care appointment detail",
			path: `${APP_PATH.transactionCarCare}/:id`,
			key: "",
			icon: <InfoOutlined />,
			component: <CarCareAppointmentDetail />,
			permissions: [PERMISSION.TRANSACTIONS.VIEW],
			hidden: true,
		},

		// Reconciliation
		{
			label: "Reconciliation",
			path: APP_PATH.transactionReconciliation,
			key: "transaction-reconciliation",
			icon: <DollarOutlined />,
			component: <Reconciliations />,
			permissions: [PERMISSION.TRANSACTIONS.RECONCILIATION],
			hidden: false,
		},
		{
			label: "Reconciliation detail",
			path: `${APP_PATH.transactionReconciliation}/:id`,
			key: "",
			icon: <InfoOutlined />,
			component: <ReconciliationDetail />,
			permissions: [PERMISSION.TRANSACTIONS.RECONCILIATION],
			hidden: true,
		},

		{
			label: "Billing infor",
			path: APP_PATH.transactionBillingInfor,
			key: "transaction-billing-infor",
			icon: <DollarOutlined />,
			component: <SubscriptionBillingInfor isShowSearch />,
			permissions: [PERMISSION.BILLING_INFORMATION.VIEW],
			hidden: false,
		},
		{
			label: "Billing Infor detail",
			path: `${APP_PATH.transactionBillingInfor}/:id`,
			key: "",
			icon: <InfoOutlined />,
			component: <SubscriptionBillingInforDetail />,
			permissions: [PERMISSION.BILLING_INFORMATION.VIEW],
			hidden: true,
		},
	],
};

export default transactionRoutes;
